export default __webpack_public_path__ + "static/media/models7.8b210e8f.jfif";